import { forwardRef } from 'react';

import { Instance } from '@spazious/dollhouse-three';

import Model, { ModelProps } from '../Model/index.js';

export interface FurnitureProps extends ModelProps {}

export const Furniture = forwardRef<Instance, FurnitureProps>(
  ({ url, context, ...restProps }, ref) => {
    return <Model ref={ref} context={context} url={url} {...restProps} />;
  }
);

export default Furniture;
